import { render, staticRenderFns } from "./EnterDataRegister.vue?vue&type=template&id=2e1a9a3a&scoped=true&"
import script from "./EnterDataRegister.vue?vue&type=script&lang=js&"
export * from "./EnterDataRegister.vue?vue&type=script&lang=js&"
import style0 from "./EnterDataRegister.vue?vue&type=style&index=0&id=2e1a9a3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1a9a3a",
  null
  
)

export default component.exports